import axios from "axios";
import { Message } from 'element-ui';
import router from "@/router";

axios.interceptors.response.use(success=>{
    //业务逻辑错误
    if(success.status && success.status === 200){
        if(success.data.code === 500 || success.data.code === 401 || success.data.code === 403){
            Message.error({message:success.data.msg});
            return;
        }
        if(success.data.msg){
            Message.success({message:success.data.msg});
        }
    }
    return success.data;
},error => {
    if(error.response.code === 504 || error.response.code === 404){
        Message.error({message:'服务器被吃了'});
    }else if(error.response.code === 403){
        Message.error({message:'权限不足'});
    }else if(error.response.code === 401){
        Message.error({message:'尚未登陆，请登录'});
        router.replace('/');
    }else {
        if(error.response.data.msg){
            Message.error({message:error.response.data.msg});
        }else {
            Message.error({message:'未知错误'});
        }
    }
    return;
});

export const postRequest= (url,params) => {
    return axios({
        method:'post',
        url:url,
        data:params
    })
}

